import { SessionService } from '@empathyco/x-utils';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, ContextState, TaggingActionPayload, TaggingState } from '../../../models';

import { TaggingService } from '../../../services';

import { CONTEXT_CONSTS } from '../../context/context.consts';

export class TagActionAction implements ActionClass {

  public static execute({ rootGetters }: ActionContext<TaggingState, any>, payload: TaggingActionPayload): Promise<void> {
    const taggingService = CONTAINER.get<TaggingService>(TYPES.TaggingService);
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const sessionId = CONTAINER.get<SessionService>(TYPES.SessionService).getSessionId();
    return taggingService.tagAction(context.instanceId, payload, sessionId);
  }

}
